
(() => {
  const body = document.body;
  const toggle = document.querySelector('[data-ln-menu-toggle]');
  const close = document.querySelector('[data-ln-menu-close]');
  const panel = document.querySelector('[data-ln-mobile-panel]');

  function setMenu(open) {
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    body.classList.toggle('ln-menu-open', open);
  }

  toggle?.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  close?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  document.querySelectorAll('.ln-nav__item').forEach((item) => {
    const link = item.querySelector('.ln-nav__link[aria-haspopup="true"]');
    item.addEventListener('mouseenter', () => link?.setAttribute('aria-expanded', 'true'));
    item.addEventListener('mouseleave', () => link?.setAttribute('aria-expanded', 'false'));
    item.addEventListener('focusin', () => link?.setAttribute('aria-expanded', 'true'));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) link?.setAttribute('aria-expanded', 'false');
    });
  });
})();
